import type { ReactNode, ButtonHTMLAttributes } from 'react'
import { Search } from 'lucide-react'

import { Button } from '@/shared/components/ui/button'
import { Input } from '@/shared/components/ui/input'
import { cn } from '@/shared/lib/utils'

/** 目录 / 创作中心列表页主操作按钮（黄色，与卡片描边一致） */
export function CatalogListPrimaryButton({
  className,
  ...props
}: ButtonHTMLAttributes<HTMLButtonElement>) {
  return <Button type="button" variant="default" size="sm" className={className} {...props} />
}

type ToolbarProps = {
  filters?: ReactNode
  actions?: ReactNode
  search?: ReactNode
  className?: string
}

/** 列表顶栏：左侧筛选，右侧操作/搜索 */
export function CatalogListToolbar({ filters, actions, search, className }: ToolbarProps) {
  const hasRight = Boolean(actions || search)

  return (
    <div
      className={cn(
        'mb-4 flex flex-col gap-3 lg:flex-row lg:items-start',
        filters ? 'lg:justify-between' : hasRight ? 'items-end lg:justify-end' : undefined,
        className,
      )}
    >
      {filters ? <div className="min-w-0 flex-1">{filters}</div> : null}
      {hasRight ? (
        <div className="flex shrink-0 flex-col gap-2 sm:flex-row sm:items-center sm:justify-end sm:gap-2">
          {actions ? <div className="flex flex-wrap items-center gap-2">{actions}</div> : null}
          {search ? <div className="w-full sm:w-[min(100%,280px)]">{search}</div> : null}
        </div>
      ) : null}
    </div>
  )
}

type SearchProps = {
  value: string
  onChange: (value: string) => void
  placeholder?: string
  className?: string
}

export function CatalogListSearch({ value, onChange, placeholder, className }: SearchProps) {
  return (
    <label className={cn('relative block w-full', className)}>
      <Search
        size={16}
        className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-zinc-500"
        aria-hidden
      />
      <Input
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className="h-9 rounded-full border-zinc-800/90 bg-zinc-900/70 pl-9 text-sm text-zinc-100 placeholder:text-zinc-500"
      />
    </label>
  )
}
